import React from 'react';
import '../styles/TableTimerCard.css';
import useTableTimerFirebase from '../pages/UseTableTimerFirebase'; // Import the custom hook

const TableTimerCard = ({ label, hourlyRate }) => {
  // Call the custom hook and get timer data and methods
  const {
    startTime,
    isRunning,
    isPaused,
    elapsedTime,
    names,
    timeDisplay,
    totalAmount,
    perPerson,
    start,
    pause,
    stop,
    updateName
  } = useTableTimerFirebase(label, hourlyRate);  // Assuming 'label' is used as the tableKey

  const handlePlayerChange = (index, value) => {
    updateName(index, value); // Update the player name in Firebase
  };

  
  return (
    <div className="table-card">
      <h3>{label}</h3>
      <div className="timer">{timeDisplay}</div>

      <div className="button-group">
        <button className="btn on" onClick={start}>ON</button>
        <button className="btn pause" onClick={pause}>{isPaused ? 'RESUME' : 'PAUSE'}</button>
        <button className="btn off" onClick={stop}>OFF</button>
      </div>

      {/* <div className="player-inputs">
        {names.map((player, i) => (
          <input
            key={i}
            type="text"
            placeholder={`Player ${i + 1}`}
            value={player}
            onChange={(e) => handlePlayerChange(i, e.target.value)}
          />
        ))}
      </div> */}


<div className="player-inputs">
  {[...names, ...Array(6 - names.length).fill('')].slice(0, 6).map((player, i) => (
    <input
      key={i}
      type="text"
      placeholder={`Player ${i + 1}`}
      value={names[i] || ''}
      onChange={(e) => handlePlayerChange(i, e.target.value)}
      disabled={isRunning} // 💥 Disable when timer is ON
    />
  ))}
</div>
      <div className="amounts">
        <p>Total: ₹{totalAmount}</p>
        <p>Per Person: ₹{perPerson}</p>
      </div>
    </div>
  );
};

export default TableTimerCard;
